export default __webpack_public_path__ + "img/list-arrow-white.154c945e.svg";